/**
 * The issue in Merlin's words, its situation tiles and the likely owner,
 * ABOVE the decision buttons (proposal 3, kanban 4d4a8707): Marcus decided
 * and sent from the text he met first, then found Merlin's "The issue" and
 * tiles below the buttons saying something else. The brief below the
 * buttons then starts at the cause chain; "Details ▸" takes the reader to it.
 */
import type { SituationTile } from './merlinBrief';
import { SituationTiles } from './SituationTiles';
import styles from './IssueSummary.module.css';

export function IssueSummaryCard({
  issue,
  tiles,
  signals = [],
  owner,
  onDetails,
}: {
  issue: string;
  tiles: SituationTile[];
  /** The thread's loaded signals, for the tiles' evidence refs. */
  signals?: ReadonlyArray<{ id: string; observation: string }>;
  /** Merlin's suggested owner; the line is left out when it named nobody. */
  owner: string;
  onDetails: () => void;
}) {
  return (
    <section className={styles.card} aria-label="The issue" data-testid="issue-summary">
      <div data-testid="brief-issue">
        <span className={styles.label}>The issue</span>
        <p className={styles.issue}>{issue}</p>
      </div>
      {tiles.length > 0 && <SituationTiles tiles={tiles} signals={signals} />}
      <p className={styles.foot}>
        {owner && <>Likely owner: {owner}. </>}
        Merlin’s full read and the email trail are under{' '}
        <button type="button" className={styles.detailsLink} onClick={onDetails}>
          Details ▸
        </button>
      </p>
    </section>
  );
}

export default IssueSummaryCard;
